import React from 'react'
import Categories from '../Components/Sections/Categories';
import About from '../Components/Sections/About';
import OurMenu from '../Components/Sections/OurMenu';
import Video from '../Components/Sections/Video';
import Team from '../Components/Sections/Team';
import FeedBack from '../Components/Sections/FeedBack';
import BlogPost from '../Components/Sections/BlogPost';
import HeroSection4 from '../Components/Sections/HeroSection4';
const Home4 = () => {
    return (
        <>
            <HeroSection4 />
            <Categories />
            <About />
            <OurMenu />
            <Video />
            <Team />
            <FeedBack />
            <BlogPost />
        </>
    )
}

export default Home4
